import script from "./CompletionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompletionModal.vue?vue&type=script&setup=true&lang=js"

import "./CompletionModal.vue?vue&type=style&index=0&id=3eaf7ac0&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eaf7ac0"]])

export default __exports__